import { Button, Drawer, Form, Input, Select, Typography } from "antd";
import { useState } from "react";
import BrandLogo0 from "../../../assets/web/images/logo-0.png";
import BrandLogo1 from "../../../assets/web/images/logo-1.png";
import BrandLogo2 from "../../../assets/web/images/logo-2.png";
import BrandLogo3 from "../../../assets/web/images/logo-3.png";
import BrandLogo4 from "../../../assets/web/images/logo-4.png";
import BrandLogo5 from "../../../assets/web/images/logo-5.png";

interface Props {
  openTryItDrawer: boolean;
  hideTryItDrawer: () => void;
}

export default function TryItDrawer({
  openTryItDrawer,
  hideTryItDrawer,
}: Props) {
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    console.log("Form Values:", values);
  };

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const brandLogos = [
    BrandLogo0,
    BrandLogo1,
    BrandLogo2,
    BrandLogo3,
    BrandLogo4,
    BrandLogo5,
  ];

  return (
    <>
      <Drawer
        title=""
        onClose={hideTryItDrawer}
        open={openTryItDrawer}
        width={600}
      >
        <div className="text-2xl font-semibold">Chose your app</div>
        <div className="text-lg mb-4">
          Free instant access, No payment required.
        </div>

        <div className="grid grid-cols-3 gap-4 mb-4">
          {brandLogos.map((logo, index) => (
            <div
              key={index}
              className="bg-white p-4 rounded-md flex items-center justify-center"
            >
              <img src={logo} className="w-full" alt="Sheba" />
            </div>
          ))}
        </div>

        <Button type="primary" block onClick={showDrawer}>
          Continue
        </Button>
      </Drawer>

      <Drawer open={open} width={600} onClose={onClose}>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Typography.Title level={3}>Chose your app</Typography.Title>
          <div>Free instant access, No payment required.</div>

          <Form.Item
            label="Your Full Name"
            name="fullName"
            rules={[
              { required: true, message: "Please enter your full name!" },
            ]}
          >
            <Input placeholder="Enter your name" />
          </Form.Item>

          <Form.Item
            label="Company Name"
            name="companyName"
            rules={[{ required: true, message: "Please enter company name!" }]}
          >
            <Input placeholder="Enter company name" />
          </Form.Item>

          <Form.Item
            label="Email Address"
            name="email"
            rules={[
              { required: true, message: "Please enter your email!" },
              { type: "email", message: "Please enter a valid email!" },
            ]}
          >
            <Input placeholder="Enter your email" />
          </Form.Item>

          <Form.Item
            label="Mobile Number"
            name="mobile"
            rules={[
              { required: true, message: "Please enter your mobile number!" },
            ]}
          >
            <Input addonBefore="+880" placeholder="017XXXXXXXX" />
          </Form.Item>

          <Form.Item
            label="Company Location"
            name="location"
            rules={[{ required: true, message: "Please select a location!" }]}
          >
            <Select placeholder="Select">
              <Select.Option value="dhaka">Dhaka</Select.Option>
              <Select.Option value="chittagong">Chittagong</Select.Option>
            </Select>
          </Form.Item>

          <div>
            By clicking on Start Now, you accept our{" "}
            <a href="#">Privacy Policy</a>
          </div>

          <div className="flex justify-between">
            <Button type="default" onClick={onClose}>
              Change app selection
            </Button>
            <Button type="primary" htmlType="submit">
              Start Now
            </Button>
          </div>
        </Form>
      </Drawer>
    </>
  );
}
